import React, {Fragment } from 'react';
import { useForm } from 'react-final-form';
import moment from 'moment';
import { FormDataConsumer, useQuery, Loading, Error, SelectInput, required, TextInput } from 'react-admin';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

let controlnums =  [];
let record = [];

const validatePKdate=(val) =>{
    let dummy = null;

    const pkdate = (document.getElementById("packing_date"))? document.getElementById("packing_date").value : null;
    if(val !== ''){
        if(!pkdate || (new Date(val)) >= (new Date(pkdate))){

            dummy = (document.getElementById("td_pkdate"))? document.getElementById("td_pkdate").setAttribute("style", "color: red;"): null;
        }else{

            dummy = (document.getElementById("td_pkdate"))?document.getElementById("td_pkdate").removeAttribute("style"):null;
        }
    }
}

const getSSN=(ucn) => {
    if(ucn === null) return '';
    
    if(controlnums.length > 0){
        record = controlnums.find(rec=> rec.control_num === ucn);
        return (record  && record.ssn)? record.ssn : '';
    }
    return '';
}

const getBleedDate=(ucn) => {
    if(ucn === null) return '';
    
   // console.log(controlnums)
   //console.log(ucn)
    if(controlnums.length > 0){
        record = controlnums.find(rec=> rec.control_num === ucn);
      //  console.log(record)
        if(record && record !== [] && record.bleed_date){
            validatePKdate( moment(record.bleed_date).format('MM/DD/YYYY'));
            return moment(record.bleed_date).format('MM/DD/YYYY');
        } 
    }
    return '';
}

const getVolume=(ucn) => {
    if(ucn === null) return '';
    
    if(controlnums.length > 0){
        record = controlnums.find(rec=> rec.control_num === ucn);
        //console.log((record && record !== [] && record.volume)?record.volume : '');
        return (record && record !== [] && record.volume)?record.volume : '';
    }
    return '';
}

const getName=(ucn) => {
    if(ucn === null) return '';
    
    if(controlnums.length > 0){
        record = controlnums.find(rec=> rec.control_num === ucn);
        
        if (record && record !== []) {
            return (record.name)?record.name : '';
        }
    }
    return '';
}

const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();

    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'ucnlist',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'bleed_date', order: 'ASC' }
        }
    });
 
    if (loading) return <Fragment><TableCell align="left" colSpan="2"><Loading /></TableCell></Fragment>;
    if (error) return <Error />;
    if (!data) return null;
    controlnums = data;
   
    return (
        <Fragment>
            <TableRow>
                    <TableCell align="left" colSpan="2">Control Unit Number<br/>
                    <SelectInput 
                        id = "ucn"
                        source="ucn"    
                        label="" 
                        choices={controlnums} 
                        validate={required()}  
                        optionText="control_num" 
                        optionValue="control_num"
                        onChange = {(value =>
                            form.change('ssn', null)),
                            value =>(
                            form.change('bleed_date', null)
                            ),
                            (value=> form.change('volume', null)
                            ),
                            (value=> form.change('name', null)
                            )
                        }
                        {...rest}
                    />      
                </TableCell>
            </TableRow>               
            <TableRow > 
                <TableCell align="left">Bleed Date<br/>
                <TextInput 
                    source="bleed_date"  
                    label="" 
                    disabled
                    value = {
                        formData.bleed_date = getBleedDate(formData.ucn)
                    }
                    {...rest}
                    /></TableCell>
                <TableCell align="left">Volume (ml)<br/>
                <TextInput 
                    source="volume" 
                    label="" 
                    disabled
                    value = {
                        formData.volume = getVolume(formData.ucn)
                    }
                    {...rest}
                /></TableCell>
            </TableRow>               
            <TableRow >  
                <TableCell align="left">SSN<br/>
                 <TextInput 
                    source="ssn"                   
                    label="" 
                    disabled
                    value = {
                        formData.ssn = getSSN(formData.ucn)
                    }
                    {...rest}
                    
                /></TableCell>         
                <TableCell align="left">Name<br/>
                    <TextInput 
                        disabled 
                        source="name" 
                        label="" 
                        value = {
                            formData.name = getName(formData.ucn)
                        }
                        {...rest}
                    /></TableCell>        
            </TableRow>
        </Fragment>
        );

};
const FormUcn = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default FormUcn